module.exports = __webpack_public_path__ + "img/cn.b4a241ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cn.png
// module id = J6D7
// module chunks = 1